import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipeDynamicCaption from "photoswipe-dynamic-caption-plugin";
import "photoswipe/style.css";

const lightbox = new PhotoSwipeLightbox({
  gallery: "#my-gallery",
  children: "a",
  showHideAnimationType: "zoom",
  pswpModule: () => import("photoswipe"),
  paddingFn: (viewportSize) => {
    return {
      top: 30,
      bottom: 30,
      left: 70,
      right: 70,
    };
  },
});

const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
  // Plugins options, for example:
  type: "auto",
});
lightbox.init();
